// Tiny Topper Co. store - small helpers
(function () {
  // keep the "my picks" count fresh when coming back with the browser's back button
  addEventListener('pageshow', function (e) {
    if (!e.persisted || !window.TT_SHOPIFY) return;
    fetch(TT_SHOPIFY.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-tt-count]').forEach(function (b) { b.textContent = c.item_count; });
    }).catch(function () {});
  });
})();
